import { Spinner } from '@/view/components/ui/spinner'
import { SupervisorsCard } from './components/SupervisorsCard'
import { useSupervisorsController } from './useSupervisorsController'
import React from 'react'
import { Button } from '../../components/ui/button'

export const Supervisores = () => {
  const { ref, data, isFetching, isLoading, hasNextPage, isFetchingNextPage } =
    useSupervisorsController()

  return (
    <div>
      <div className="flex items-end justify-between">
        <h2 className="mb-8 text-2xl font-semibold">Supervisores</h2>
      </div>

      {isLoading ? (
        <div className="mt-8 flex items-center justify-center">
          <Spinner />
        </div>
      ) : (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(386px, 1fr))',
            gap: '16px',
          }}
        >
          {data &&
            data.pages.map((page, pageIndex) => {
              const sortedManagers = [...page.data].sort(
                (a, b) => b.transactions.total - a.transactions.total,
              )

              return (
                <React.Fragment key={pageIndex}>
                  {sortedManagers.map((supervisors) => {
                    return (
                      <SupervisorsCard
                        key={supervisors._id}
                        {...supervisors}
                        commissionsV2={supervisors.commissionsV2}
                      />
                    )
                  })}
                </React.Fragment>
              )
            })}
        </div>
      )}

      <div className="mt-2 flex items-center justify-center" ref={ref}>
        <Button variant="ghost" disabled={!hasNextPage || isFetchingNextPage}>
          {isFetchingNextPage ? <Spinner /> : null}
        </Button>
      </div>

      {isFetching && !isFetchingNextPage && !isLoading ? (
        <div className="mt-4 flex items-center justify-center">
          <Spinner />
        </div>
      ) : null}
    </div>
  )
}
